import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import Loading from "../../../components/loading";
import Error from "../../../components/Error";
import NoDataTable from "../../../components/noDataTable";
import TableActions from "../../../components/tableActions";
import ParagraphHighliter from "../../../components/paragraphHighliter";
import { useTranslation } from "react-i18next";

const ListViewIngrediants = ({
  ingrediants,
  page,
  limit,
  handleClickOpen,
  handleModify,
  status,
  error,
  search,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <TableContainer>
      <Table sx={{ backgroundColor: colors.primary[400] }}>
        <TableHead sx={{ backgroundColor: colors.primary[700] }}>
          <TableRow>
            <TableCell sx={{ width: 60 }}>{t("table.number")}</TableCell>
            <TableCell sx={{ width: 90 }}>{t("table.image")}</TableCell>
            <TableCell sx={{ width: "100%", whiteSpace: "nowrap" }}>
              {t("table.name")}
            </TableCell>
            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
              {t("table.price")}
            </TableCell>
            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
              {t("fields.extraPrice")}
            </TableCell>
            <TableCell sx={{ whiteSpace: "nowrap" }}>
              {t("table.options")}
            </TableCell>
            <TableCell sx={{ whiteSpace: "nowrap" }}>
              {t("table.visibility")}
            </TableCell>
            <TableCell sx={{ whiteSpace: "nowrap" }}>
              {t("table.availability")}
            </TableCell>
            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
              {t("table.actions")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {status === "loadingFetchDataPaginated" ? (
            <TableRow>
              <TableCell colSpan={9} align="center">
                <Loading size={8} />
              </TableCell>
            </TableRow>
          ) : status === "fetchErrorPaginated" ? (
            <TableRow>
              <TableCell colSpan={9} align="center">
                <Error>{error}</Error>
              </TableCell>
            </TableRow>
          ) : ingrediants && ingrediants.length > 0 ? (
            ingrediants.map((item, index) => (
              <TableRow key={item._id} hover>
                <TableCell>{page * limit + index + 1}</TableCell>
                <TableCell>
                  <img
                    src={`${process.env.REACT_APP_MEDIA_URL}/${item.image}`}
                    alt={item.name}
                    style={{
                      width: "48px",
                      height: "48px",
                      objectFit: "contain",
                    }}
                  />
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  <ParagraphHighliter title={item?.name} search={search} />
                </TableCell>
                <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                  <Typography component="span" sx={{ fontWeight: "bold" }}>
                    {item.price ?? 0}
                  </Typography>
                </TableCell>
                <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                  {item.suppPrice ?? 0}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  {item.types?.[0]?.name ?? "—"}
                  {item.types?.length > 1 && (
                    <Tooltip
                      title={
                        <div>
                          {item.types.slice(1).map((type) => (
                            <div key={type._id}>{type.name}</div>
                          ))}
                        </div>
                      }
                      arrow
                    >
                      <Chip
                        size="small"
                        label={`+${item.types.length - 1}`}
                        color="default"
                        sx={{ ml: 0.5, borderRadius: "50%" }}
                      />
                    </Tooltip>
                  )}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  <Chip
                    variant="outlined"
                    label={item.visible ? "Visible" : "Caché"}
                    color={item.visible ? "success" : "error"}
                  />
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  <Chip
                    variant="outlined"
                    label={item.outOfStock ? "Rupture de stock" : "En stock"}
                    color={item.outOfStock ? "error" : "success"}
                  />
                </TableCell>
                <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                  <TableActions
                    actions={[
                      {
                        type: "delete",
                        color: "error",
                        label: t("common.delete"),
                        onClick: () => handleClickOpen(item._id),
                      },
                      {
                        type: "edit",
                        color: "warning",
                        label: t("common.edit"),
                        onClick: () => handleModify(item),
                      },
                    ]}
                  />
                </TableCell>
              </TableRow>
            ))
          ) : (
            <NoDataTable cols={9} />
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ListViewIngrediants;
